import React, {useState, useEffect, useRef} from 'react';
import {GoogleMap, LoadScript, Marker, Polyline} from "@react-google-maps/api";
import {mapOptions} from "./mapOptions";
import Constants from "../../constants/Constants";
import './style.scss'
import marker from '../../../src/assets/images/marker.png';

const containerStyle = {
    width: '100%',
    height: '100%'
};

const center = {
    lat: 46.745,
    lng: 38.523
};


const Map = ({pathArr}) => {
    const [bounds] = useState(null);
    const [icons, setIcons] = useState([{}]);
    const [map, setMap] = useState(null);
    // Вычисляем границы всех полилиний
    useEffect(() => {
        if (pathArr && pathArr.length > 0 && map) {
            const bounds = new window.google.maps.LatLngBounds();
            pathArr.forEach((path) => {
                path.forEach((point) => {
                    if (isNaN(point.lat) || isNaN(point.lng)) {
                        return;
                    }
                    bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
                });
            });
            map.fitBounds(bounds); // установка зума, чтобы все полилинии были видны на карте
        }
    }, [pathArr, map]);

    // Анимация полилиний
    let timerId = useRef().current
    const animate = () => {
        let count = 0;
        timerId = setInterval(() => {
            count = (count + 1) % 200;
            const newIcons = icons.map((icon) => ({
                icon: {
                    path: "M19.7609 8.73347L15.3536 10.2682L13.1006 19.0645C13.06 19.3781 12.7959 19.6947 12.4388 19.7442L11.5039 20.0697C10.8361 20.3023 10.1129 19.7305 10.1939 19.1033L10.7692 11.9395L6.22832 13.5208L5.45086 15.5885C5.32029 15.8586 5.09968 16.0852 4.83257 16.1782L3.36346 16.6898L2.99613 12.6247L0.759023 9.21072L2.22515 8.47554C2.49226 8.38253 2.80588 8.42307 3.07597 8.55364L4.96962 9.69122L9.5105 8.10995L4.51997 2.80952C4.11035 2.27828 4.27847 1.47098 4.94625 1.23844L5.88114 0.91289C6.14825 0.819874 6.5519 0.903937 6.82199 1.03451L14.0514 6.52869L18.4587 4.99393C19.5271 4.62186 20.6075 5.14415 20.9796 6.21259V6.21259C21.3516 7.28103 20.8294 8.36141 19.7609 8.73347V8.73347Z M5.3089420146640975,10.05284487634605L9.780486660771459,8.508129453145322 M5.634145261653728,10.459348935083078L9.943088284266281,8.914633511882357 M5.715446073401139,10.784552182072709L10.10568990776109,9.077235135377165 M6.040649320390755,11.191056240809736L10.43089315475072,9.4837391941142 M6.284551755632975,11.434958676051956L10.593494778245528,9.80894244110383 M6.691055814370017,11.597560299546771L10.67479558999294,10.378048123335674 M6.772356626117415,12.08536517003121L10.756096401740336,10.784552182072709 M6.528454190875195,12.65447085226306L20.34959218793432,8.101625394408288 M10.756096401740336,11.353657864304552L3.2764217209789375,14.361787898958598 M15.146340236100302,10.215446499840859L8.967478543297403,12.166665981778621 M20.430892999681717,7.369918088681629L3.4390233444737532,13.873983028474157 M3.4390233444737532,13.223576534494903L20.756096246671348,6.556909971207567 M3.2764217209789375,12.491869228768245L20.51219381142913,6.069105100723128 M3.0325192857367185,11.841462734788989L20.34959218793432,5.662601041986093 M2.7886168504944995,11.272357052557147L19.86178731744988,5.33739779499647 M2.4634136035048684,10.947153805567515L18.9674783882284,5.256096983249059 M11.243901272224775,11.760161923041586L10.67479558999294,19.239836603802992 M11.731706142709212,11.434958676051956L11.162600460477378,19.321137415550396 M12.46341344843587,11.191056240809736L11.650405330961817,19.321137415550396 M13.032519130667723,10.947153805567515L12.056909389698845,19.48373903904521 M13.357722377657355,10.703251370325297L12.46341344843587,19.15853579205558 M14.0081288716366,10.54064974683049L12.869917507172914,18.91463335681336 M14.739836177363259,10.134145688093454L13.601624812899573,15.418698451674876 M4.577234708937439,2.16666613684761L9.86178747251887,8.020324582660884 M4.65853552068485,1.5975604546157631L10.593494778245528,8.182926206155699 M4.90243795592707,1.2723572076261398L10.999998836982556,8.020324582660884 M5.634145261653728,1.1910563958787321L11.813006954456625,8.426828641397918 M5.796746885148536,1.0284547723839168L11.487803707466995,7.532519712176445 M6.772356626117415,1.3536580193735441L13.764226436394381,6.8821132181971905 M6.284551755632975,1.4349588311209516L13.357722377657355,7.288617276934225 M8.723576108055184,3.6300807483009265L12.707315883678106,7.69512133567126 M1.3252022390411824,9.321137570619385L2.9512184739893144,11.353657864304552 M1.650405486030806,8.995934323629761L3.2764217209789375,11.191056240809736 M2.219511168262649,8.914633511882357L3.4390233444737532,10.459348935083078 M2.707316038747095,8.426828641397918L3.845527403210781,10.215446499840859 M3.5203241562211574,9.23983675887198L4.33333227369522,9.80894244110383 M3.4390233444737532,14.19918627546378L3.845527403210781,15.906503322159317 M3.764226591463377,14.117885463716377L4.33333227369522,15.906503322159317 M4.414633085442631,13.792682216726746L4.577234708937439,15.662600886917097 M5.065039579421878,13.548779781484527L4.90243795592707,15.49999926342229 M5.715446073401139,13.223576534494903L5.227641202916701,15.581300075169693 M11.569104519214408,19.565039850792616L10.837397213487746,19.64634066254002 M12.138210201446256,11.028454617314928L11.650405330961817,17.04471468662301 M3.5203241562211574,12.735771664010462L20.83739705841876,6.9634140299445955 M12.138210201446256,7.613820523923849L7.341462308349264,2.898373442574268 M20.26829137618691,5.987804288975717L10.593494778245528,10.215446499840859 M3.1138200974841226,12.004064358283804L5.878047696895948,11.191056240809736 M2.4634136035048684,11.516259487799367L5.3089420146640975,10.54064974683049 M3.2764217209789375,13.467478969737124L20.99999868191357,7.532519712176445 M15.227641047847698,8.995934323629761L13.276421565909942,16.719511439633386 M20.34959218793432,6.231706724217935L11.162600460477378,10.621950558577893",
                    strokeOpacity: 1,
                    scale: 1,
                    rotation: -75,
                    strokeColor: '#F3D298',
                    fillColor: '#F3D298',
                    anchor: { x: 0, y: 12 }
                },
                offset: `${(count / 2) % 100}%`
            }));
            setIcons(newIcons);
        }, 40);
    };


    useEffect(() => {
        animate();
        return () => {
            clearInterval(timerId)
        }
    }, [timerId]);

    // При изменении bounds изменяем зум
    useEffect(() => {
        if (map && bounds) {
            map.fitBounds(bounds);
        }
    }, [map, bounds]);


    return (
        <div className={`map-wrapper ${(pathArr[0] && pathArr[0][0]) || (pathArr[0] && pathArr[0][1]) ? 'opened' : 'hidden'}`} >
            <LoadScript
                googleMapsApiKey={Constants.API_KEY}
            >
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={bounds?.getCenter() ?? center}
                    zoom={3}
                    options={mapOptions}
                    onLoad={(map) => setMap(map)}
                >
                    {/* дополнительный код для добавления маркеров или других элементов на карту */}
                    {pathArr && pathArr.map((path, index) => (
                        <React.Fragment key={index}>
                            { path[0] && (
                                <Marker
                                    key={path[0].lat}
                                    position={path[0]}
                                    icon={{
                                        url: marker,
                                        anchor: { x: 9, y: 12 }
                                    }}
                                />
                            )}
                            {
                                path[1] && (
                                    <Marker
                                        key={path[1].lat}
                                        position={path[1]}
                                        icon={{
                                            url: marker,
                                            anchor: { x: 9, y: 10 }
                                        }}
                                    />
                                )
                            }

                            {
                                (path[0] && path[1] && <Polyline
                                    key={path[0].lng}
                                    path={path}
                                    options={{
                                        geodesic: true,
                                        strokeColor: "#F3D298",
                                        strokeOpacity: 1,
                                        strokeWeight: 1,
                                        clickable: false,
                                        draggable: false,
                                        editable: false,
                                        visible: true,
                                        zIndex: 1,
                                        icons: icons
                                    }}
                                />)
                            }
                        </React.Fragment>
                    ))
                    }
                </GoogleMap>
            </LoadScript>
        </div>
    )
};

export default Map;

